function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M30,6.7l6.6,14l0.7,1.4l1.6,0.2l15,2.3L42.9,35.9l-1.1,1.1l0.2,1.5l2.5,15.6l-13.1-7.3L30,46l-1.5,0.8l-13.1,7.3 L18,38.4l0.2-1.5l-1.1-1.1L6.2,24.7l15-2.3l1.6-0.2l0.7-1.4L30,6.7 M30-0.3l-9.3,19.8L0,22.6L15,38l-3.5,21.7L30,49.4 l18.5,10.2L45,38l15-15.4l-20.7-3.2L30-0.3L30-0.3z"
}))))), React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M30,23.2l1.8,3.8l0.7,1.4l1.6,0.2l5.2,0.8l-3.9,4l-1.1,1.1l0.2,1.5l0.8,4.9l-3.9-2.2L30,38l-1.5,0.8L24.7,41l0.8-4.9 l0.2-1.5l-1.1-1.1l-3.9-4l5.2-0.8l1.6-0.2l0.7-1.4L30,23.2 M30,16.1l-4.5,9.6l-11,1.7l8,8.2l-1.8,11l9.3-5.1l9.3,5.1l-1.8-11 l8-8.2l-11-1.7L30,16.1L30,16.1z"
}))))));

var SvgStar = function SvgStar(props) {
  return React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 60 60",
    style: {
      enableBackground: "new 0 0 60 60"
    },
    xmlSpace: "preserve"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/star.b77dbce9.svg";
export { SvgStar as ReactComponent };